import React from 'react';

/**
 * ErrorBoundary that catches errors thrown by third-party iframe embeds
 * (e.g. Spotify's locale RangeError) and renders a graceful fallback
 * instead of blanking the entire page.
 */
class IframeErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    // Swallow third-party embed errors quietly; log only in dev
    if (process.env.NODE_ENV !== 'production') {
      // eslint-disable-next-line no-console
      console.warn('[IframeErrorBoundary] suppressed embed error', error?.message);
    }
  }

  render() {
    if (this.state.hasError) {
      return (
        <div
          className="rounded-xl border border-white/10 bg-white/5 p-4 text-center text-gray-400 text-sm"
          data-testid="iframe-error-fallback"
        >
          {this.props.fallbackLabel || 'Embed unavailable.'}{' '}
          {this.props.url && (
            <a
              href={this.props.url}
              target="_blank"
              rel="noopener noreferrer"
              className="text-amber-400 hover:text-amber-300 underline"
            >
              Open in new tab
            </a>
          )}
        </div>
      );
    }
    return this.props.children;
  }
}

export default IframeErrorBoundary;
